import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

const SectionLink = styled(Link)`
  color: rebeccapurple;
  letter-spacing: 0.25px;
  margin-top: 20px;
  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
  &:visited {
    color: rebeccapurple;
  }
`

export default SectionLink;



// WEBPACK FOOTER //
// ./src/components/Shared/SectionLink.js